import { render, staticRenderFns } from "./sxitem.vue?vue&type=template&id=556da6bc&scoped=true"
import script from "./sxitem.vue?vue&type=script&lang=js"
export * from "./sxitem.vue?vue&type=script&lang=js"
import style0 from "./sxitem.vue?vue&type=style&index=0&id=556da6bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556da6bc",
  null
  
)

export default component.exports